'use client';

const getLabelId = (id) => `chalk-menu-item-label-${id}`;
const getCaptionId = (id) => `chalk-menu-item-caption-${id}`;
export {
  getCaptionId,
  getLabelId
};
